// Must stay the first import: moves legacy storage keys before anything reads them.
import "lib/migrateStorage";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import store from "store";
import { unregister } from "lib/serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

unregister();
